const testimonials = [
  {
    testimony: `“It is about building a Nigeria where our diaspora community is seen, heard and harnessed; not just celebrated occasionally, but embedded structurally.” 

“We are going to launch the Diaspora Home and Abroad platform. This is a platform that makes it possible for the Diaspora to be able to own their homes. Diasporas will no longer be duped as long as they use the platform.”`,
    author: "Dr. Abike Dabiri-Erewa",
    jobTitle: "Chairman of NiDCOM",
  },
  {
    testimony: `Home and Abroad is set to alter the property purchase process in Nigeria, as the platform has adopted innovative features to check the distance barrier and offer prospective buyers a full view of the property in Nigeria from wherever they are in the world. The platform brings housing solutions to diasporas that come with a sense of peace of mind.`,
    author: "Christopher Epum",
    jobTitle: "Manager, Home and Abroad Platform ",
  },
  {
    testimony: `“This platform aligns with our mission to enable secure financial services and deepen trust between the diaspora and home-based institutions”`,
    author: "Abimbola Meshinoye",
    jobTitle: "Head of Brand Strategy & Financial Planning, FirstBank Plc",
  },
];

const Testimonial = () => {
  return (
    <div>
      <section className="px-4 sm:px-10 font-poppins flex flex-col items-center lg:px-[175px] py-[30px]">
        <div className="flex w-full items-center flex-col justify-between max-w-[1106px]">
          <div className="flex items-center justify-between w-full">
            <h4 className="text-textBlack text-[22px] lg:text-[36px] font-semibold">
              What People Are Saying About Home and Abroad 
            </h4>
            <div className="hidden lg:flex items-center gap-2">
              <div className="w-[44px] h-[44px] flex items-center justify-center rounded-full hover:bg-primary/5 transition duration-300 hover:cursor-pointer bg-primary/10">
                <img src="/assets/images/arrow-left-n.svg" alt="" />
              </div>
              <div className="w-[44px] h-[44px] flex items-center justify-center rounded-full hover:bg-primary/5 transition duration-300 hover:cursor-pointer bg-primary/10">
                <img
                  src="/assets/images/arrow-left-n.svg"
                  alt=""
                  className="transform rotate-180"
                />
              </div>
            </div>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-[35px] mt-5 gap-y-[33px]">
            {testimonials.map((testimony, index) => (
              <div
                key={index}
                className="property-card p-6 rounded-[10px] flex flex-col gap-[30px]"
              >
                <img
                  src="/assets/images/quotation-icon.svg"
                  className="w-5"
                  alt=""
                />
                <p className="whitespace-pre-line">{testimony.testimony}</p>
                <div className="flex flex-col pl-4 gap-2 border-l-[2px] border-primary">
                  <h3 className="font-poppins font-medium text-textBlack">
                    {testimony.author}
                  </h3>
                  <span className="text-[14px]">{testimony.jobTitle}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <p></p>
    </div>
  );
};

export default Testimonial;
